import { SelectOption } from "@pulseops/common";

export namespace ACMetricHistoryDetailConst {
  export const StatusConstList: SelectOption[] = [
    {
      label: 'New request',
      value: 'New request'
    },
    {
      label: 'Approved',
      value: 'Approved'
    }
    , {
      label: 'Rejected',
      value: 'Rejected'
    }
  ]
}